import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b73c9a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "worp"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header_left" }
const _hoisted_4 = { class: "header_right" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "action" }
const _hoisted_7 = {
  key: 0,
  class: "mod_pagin"
}
const _hoisted_8 = {
  key: 1,
  class: "worp_swt"
}

import { defineAsyncComponent, reactive, ref, watch, getCurrentInstance, computed, unref } from 'vue';
import { Input, Table, Pagination, Switch, Modal, Button, Tooltip, message, Select, notification } from 'ant-design-vue';
import { SearchOutlined } from '@ant-design/icons-vue';
import { Key } from 'ant-design-vue/lib/_util/type';
import {
  RootModal,
  MoreFormType,
  Imodal,
  DataType,
  DetailsForm,
  AnswerListClass,
  AnswerType,
  Options,
  AnswerTurnClass,
} from './type';
import CDelModal from '@/components/CDelModal.vue';
import CreateView from './AnswerView/CreateView.vue';
import SvgIcon from '@/components/SvgIcon.vue'; // svg component
import http from '@/api';
import { useRoute } from 'vue-router';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { getToken } from '@/plugins/cookie';
import { onExport } from '@/components/CExport'; //导出
import https from '@/api/exportList';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnswerViewing',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: boolean };

const CensusModal = defineAsyncComponent(() => import('./AnswerView/CensusModal.vue'));
const MoreModal = defineAsyncComponent(() => import('./AnswerView/MoreModal.vue'));
const DetailsModal = defineAsyncComponent(() => import('./AnswerView/DetailsModal.vue'));
const OrderModal = defineAsyncComponent(() => import('./AnswerView/OrderModal.vue'));

const aInputSearch = Input.Search;
const aTable = Table;
const aPagination = Pagination;
const aSwitch = Switch;
const aModal = Modal;
const aButton = Button;
const aTooltip = Tooltip;
const aSelect = Select;

const route = useRoute();
const studioId = computed(() => route.params.studioId);
const state = ref(false);
const columns = [
  { title: '序号', dataIndex: 'serialNumber', key: 'serialNumber', width: 100 },
  { title: '题目名称', dataIndex: 'title', key: 'title', ellipsis: 'true' },
  { title: '试题题型', dataIndex: 'type', key: 'type' },
  { title: '答题次数', dataIndex: 'num', key: 'num' },
  { title: '修改时间', dataIndex: 'time', key: 'time', sorter: (a: any, b: any) => (a.time > b.time ? 1 : -1) },
  { title: '题目操作', dataIndex: 'state', key: 'state', width: 180, slots: { customRender: 'state' } },
];
const dataSource = ref<AnswerListClass[]>([]);

const statusOpeion: Options[] = [
  { label: '单选题', value: 1 },
  { label: '多选题', value: 2 },
  { label: '全部', value: 3 },
];

const form = reactive({
  select: undefined,
  keywords: '',
});

const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 0, // 总页数
  options: ['10', '24', '36', '48', '60'], // 选项
  size: 'small', // 尺寸
  showJumper: false, // 是否显示跳页
  showSize: false, // 是否显示条数切换
});

// 获取列表数据
const getList = () => {
  const data = { studio_id: studioId.value, keyword: form.keywords, page: pageConfig.current, page_num: pageConfig.pageSize };
  http.liveAnswer
    .getAnswerList({ params: data })
    .then((res) => {
      const resData = res.data.data;
      state.value = Boolean(resData.status);
      dataSource.value = resData.data.data ? resData.data.data.map((e: any) => new AnswerListClass(e)) : [];
      work.value = resData.data.data ? resData.data.data.map((e: any) => new AnswerListClass(e)) : [];
      pageConfig.totalSize = resData.data.total;
    })
    .catch((err) => console.error(err));
};
getList();

// 选择筛选
const work = ref<AnswerListClass[]>([]);
const selChange = (val: number) => {
  dataSource.value = work.value;
  if (val === 1) {
    dataSource.value = dataSource.value.filter((e) => e.type === '单选');
  } else if (val === 2) {
    dataSource.value = dataSource.value.filter((e) => e.type === '多选');
  }
};

// 选择标记
const selectedRowKeys = ref<Key[]>([]);
const onSelectChange = (selectedRowKey: Key[]) => {
  console.log('selectedRowKeys changed: ', selectedRowKey);
  selectedRowKeys.value = selectedRowKey;
};
const getSelected = computed(() => Boolean(selectedRowKeys.value.length));
// 答题统计
const censusModal = reactive<RootModal>({ title: '答题统计', visible: false });
const openCensusModal = () => {
  censusModal.visible = !censusModal.visible;
};
const exDisabled = ref(false);
const getClickDis = (data: boolean) => {
  exDisabled.value = data;
};
// 更多设置
const moreModal = reactive<RootModal>({ title: '更多设置', visible: false });
const openMoreModal = () => {
  moreModal.visible = !moreModal.visible;
};
const moreForm = ref<MoreFormType>({ answer_mode: 0, answer_operation: 0 });
const getMoreConfig = () => {
  http.liveAnswer
    .getMoreConfig({ params: { studio_id: studioId.value } })
    .then((res) => {
      moreForm.value = res.data.data;
    })
    .catch((err) => console.error(err));
};
getMoreConfig();

const setMore = () => {
  if (moreForm.value.answer_mode !== 3) moreForm.value.answer_count = undefined;
  const data = { ...moreForm.value, studio_id: studioId.value };
  http.liveAnswer
    .answerConfigSave(data)
    .then((res) => {
      message.success(res.data.message);
      openMoreModal();
    })
    .catch((err) => message.error(err.data.error));
};

// 排序
const ordeModal = reactive<RootModal>({ title: '排序', visible: false });
const openOrderModal = () => {
  ordeModal.visible = !ordeModal.visible;
};
const setOrderList = () => {
  const idArr = Array<any>();
  dataSource.value.forEach((e) => {
    idArr.push(e.id);
  });
  http.liveAnswer
    .setAnswerOrder({ ids: JSON.stringify(idArr) })
    .then(() => {
      message.success('操作成功！');
      ordeModal.visible = false;
      getList();
    })
    .catch((err) => message.error(err.data.error));
};
const closeOrder = () => {
  ordeModal.visible = false;
  getList();
};

// 详情
const detailsModal = reactive<RootModal>({ title: '查看详情', visible: false });
const detailsForm = ref<DetailsForm[]>([{ title: '', answerArr: [] }]);
const openDetailsModal = (record: any) => {
  detailsModal.visible = true;
  detailsForm.value[0].title = record.title;
  detailsForm.value[0].answerArr = record.option;
};
const closeDetailsModal = () => {
  detailsModal.visible = false;
};

// 删除
const delKey = ref();
const delItem = ref();
const delModal = reactive<Imodal>({
  title: '删除',
  visible: false,
  loading: false,
});
const openDelModal = (key: number, record?: AnswerListClass) => {
  delKey.value = key;
  delItem.value = record;
  delModal.visible = true;
};
const delClick = () => {
  let data = {};
  if (delKey.value === 1) {
    data = { studio_id: studioId.value, id: selectedRowKeys.value.join(',') };
  }
  if (delKey.value === 0) {
    data = { studio_id: studioId.value, id: delItem.value.id };
  }
  http.liveAnswer
    .delAnswerList(data)
    .then((res) => {
      message.success(res.data.message);
      delModal.visible = false;
      getList();
    })
    .catch((err) => message.error(err.data.error));
};

// 编辑1&新建0

const setCreat = ref(false);
setCreat.value = unref(props.modelValue);
watch(
  () => props.modelValue,
  () => {
    setCreat.value = props.modelValue;
    if (!setCreat.value) {
      backDataView();
    }
  }
);

const subjectForm = ref<DataType[]>([]);
const viewType = ref();
const openDataView = async (type: number, record?: any) => {
  // 0 新建 1编辑
  try {
    setCreat.value = true;
    viewType.value = type;
    if (type) {
      const resData = await http.liveAnswer.getAnswerInfo({ params: { studio_id: studioId.value, id: record.id } });
      const arr = JSON.parse(resData.data.data.option).map((e: AnswerTurnClass) => new AnswerType(e));
      subjectForm.value.push({
        id: resData.data.data.id,
        title: record.title,
        answerArr: arr,
        check: false,
        type: resData.data.data.answer_type,
        num: record.num,
        mustRight: Boolean(resData.data.data.answer_require),
        message: Boolean(resData.data.data.answer_tip),
        showdetails: true,
        showEditor: false,
      });
    }
    if (!type) {
      subjectForm.value.push({
        title: '',
        answerArr: [
          { answer: ' ', answerTrue: false },
          { answer: ' ', answerTrue: false },
          { answer: ' ', answerTrue: false },
          { answer: ' ', answerTrue: false },
        ],
        check: false,
        type: 1,
        num: 0,
        mustRight: false,
        message: false,
        showdetails: false,
        showEditor: true,
      });
    }
  } catch (err: any) {
    console.error(err?.data?.error);
  }
};

const backDataView = () => {
  setCreat.value = false;
  subjectForm.value = [];
  viewType.value = undefined;
};

watch(setCreat, (newVal) => {
  emit('update:modelValue', newVal);
});

const { proxy }: any = getCurrentInstance();
const corn = ref(1);
const messageTip = ref();
const exportCensusList = useDebounce(() => {
  const data = {
    studio_id: studioId.value,
    type: 39,
    is_cron_download: corn.value,
  };
  https
    .excel_regional_distribution({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};

// 开关
const changeStatus = useDebounce((info: any) => {
  message.destroy();
  if (state.value && dataSource.value.length === 0) {
    message.warning('请先添加题目！');
    state.value = false;
    return;
  } else {
    http.liveAnswer
      .answerStatus({ studio_id: studioId.value, status: state.value ? 1 : 0 })
      .then((res) => {
        if (info) message.success(res.data.message);
      })
      .catch((err) => message.error(err.data.error));
  }
});

watch(
  () => dataSource.value,
  () => {
    if (dataSource.value.length === 0 && state.value) {
      state.value = false;
      changeStatus(false);
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!setCreat.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(aSelect), {
                class: "mod_select header_btn",
                value: form.select,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.select) = $event)),
                options: statusOpeion,
                placeholder: "全部",
                onChange: selChange
              }, null, 8, ["value"]),
              _createVNode(_unref(aInputSearch), {
                class: "mod_range_picker_search",
                value: form.keywords,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.keywords) = $event)),
                placeholder: "请输入题目",
                onSearch: getList
              }, {
                enterButton: _withCtx(() => [
                  _createVNode(_unref(SearchOutlined))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(aButton), {
                type: "primary",
                class: "header_right_but",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (openDataView(0)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新建题型")
                ]),
                _: 1
              }),
              _createVNode(_unref(aButton), {
                class: "header_right_but",
                onClick: openCensusModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode("答题统计")
                ]),
                _: 1
              }),
              _createVNode(_unref(aButton), {
                class: "header_right_but",
                onClick: openMoreModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode("更多设置")
                ]),
                _: 1
              }),
              _createVNode(_unref(aButton), {
                class: "header_right_but",
                onClick: openOrderModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode("排序")
                ]),
                _: 1
              }),
              _createVNode(_unref(aButton), {
                class: "header_right_but",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (openDelModal(1))),
                disabled: !_unref(getSelected)
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除")
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(aTable), {
              class: "ant-table-striped",
              "row-selection": { selectedRowKeys: selectedRowKeys.value, onChange: onSelectChange },
              columns: columns,
              "data-source": dataSource.value,
              pagination: false,
              "row-key": "id",
              size: "small"
            }, {
              state: _withCtx(({ record }) => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(aTooltip), null, {
                    title: _withCtx(() => [
                      _createTextVNode("详情")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(aButton), {
                        type: "link",
                        class: "action_btn",
                        onClick: ($event: any) => (openDetailsModal(record))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, { "icon-class": "vote_img" })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(aTooltip), null, {
                    title: _withCtx(() => [
                      _createTextVNode("修改")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(aButton), {
                        type: "link",
                        class: "action_btn",
                        onClick: ($event: any) => (openDataView(1, record))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, { "icon-class": "vote_imge" })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(aTooltip), null, {
                    title: _withCtx(() => [
                      _createTextVNode("删除")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(aButton), {
                        type: "link",
                        class: "action_btn",
                        onClick: ($event: any) => (openDelModal(0, record))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, { "icon-class": "document" })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              _: 1
            }, 8, ["row-selection", "data-source"])
          ]),
          (dataSource.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_unref(aPagination), {
                  "show-quick-jumper": "",
                  total: pageConfig.totalSize,
                  current: pageConfig.current,
                  "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => ((pageConfig.current) = $event)),
                  "page-size": pageConfig.pageSize,
                  "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((pageConfig.pageSize) = $event)),
                  pageSizeOptions: pageConfig.options,
                  "show-less-items": "",
                  "show-size-changer": "",
                  onChange: getList,
                  onShowSizeChange: getList
                }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!setCreat.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createTextVNode(" 功能开关： "),
          _createVNode(_unref(aSwitch), {
            checked: state.value,
            "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((state).value = $event)),
            onChange: _unref(changeStatus)
          }, null, 8, ["checked", "onChange"])
        ]))
      : (_openBlock(), _createBlock(CreateView, {
          key: 2,
          "onClick:back": backDataView,
          "onClick:save": getList,
          dataForm: subjectForm.value,
          viewType: viewType.value
        }, null, 8, ["dataForm", "viewType"])),
    _createVNode(_unref(aModal), {
      visible: censusModal.visible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((censusModal.visible) = $event)),
      width: "80%",
      style: {"min-width":"800px"},
      centered: "",
      title: censusModal.title
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(aButton), {
          key: "back",
          onClick: openCensusModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_unref(aButton), {
          key: "submit",
          type: "primary",
          disabled: exDisabled.value,
          onClick: _unref(exportCensusList)
        }, {
          default: _withCtx(() => [
            _createTextVNode("导出")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(CensusModal), { "onClick:disabled": getClickDis })
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_unref(aModal), {
      visible: moreModal.visible,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((moreModal.visible) = $event)),
      width: "560px",
      centered: "",
      title: moreModal.title,
      onOk: setMore
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MoreModal), {
          modelValue: moreForm.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((moreForm).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_unref(aModal), {
      visible: ordeModal.visible,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((ordeModal.visible) = $event)),
      width: "760px",
      centered: "",
      title: ordeModal.title,
      onOk: setOrderList,
      onCancel: closeOrder
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(OrderModal), {
          modelValue: dataSource.value,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dataSource).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_unref(aModal), {
      visible: detailsModal.visible,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((detailsModal.visible) = $event)),
      width: "750px",
      centered: "",
      title: detailsModal.title,
      onOk: closeDetailsModal
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(DetailsModal)), {
          modelValue: detailsForm.value,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((detailsForm).value = $event))
        }, null, 8, ["modelValue"]))
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(CDelModal, {
      visible: delModal.visible,
      centered: "",
      close: () => (delModal.visible = false),
      ok: delClick
    }, null, 8, ["visible", "close"])
  ], 64))
}
}

})